import { TOKEN_CREATION_ERRORS } from './constants'

export const mapNewTokenErrorToMessage = (error) => {
  const { TOKEN_SYMBOL_EXISTS } = TOKEN_CREATION_ERRORS
  if (error === TOKEN_SYMBOL_EXISTS) {
    return 'Please choose a different token symbol!'
  }
  return null
}
